module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-img1-cc1b774a1e6fd250ab916256cb636f94.jpg";